import * as React from 'react';

import type { InstructorsPendingLetterContextValue } from './InstructorsPendingLetterContext.types';

import { InstructorsPendingLetterContext } from './InstructorsPendingLetterProvider';

export function useInstructorsPendingLetterData(): InstructorsPendingLetterContextValue {
  const context = React.useContext(InstructorsPendingLetterContext);

  if (!context) {
    throw new Error(
      'useInstructorsPendingLetterData must be used within InstructorsPendingLetterProvider'
    );
  }

  return context;
}
